import React from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {
  iconButton,
  iconButtonImage,
  iconButtonImageLarge,
  iconButtonLarge,
  iconButtonText,
  iconButtonTextLarge,
} from '#Client/components/IconButton/IconButton.css';

type IconButtonProps = {
  text: string;
  icon: string;
  large?: boolean;
  onClick: () => void;
};

export const IconButton = ({text, icon, large, onClick}: IconButtonProps) => {
  return (
    <button
      className={`${iconButton} ${large ? iconButtonLarge : ''}`}
      onClick={onClick}
    >
      <span className={`${iconButtonText} ${large ? iconButtonTextLarge : ''}`}>
        {text}
      </span>
      <img
        className={`${iconButtonImage} ${large ? iconButtonImageLarge : ''}`}
        src={`${IMG_DIR}${icon}`}
      />
    </button>
  );
};
